  (function () {
    if (window.__sjwCurrencySelectorLoaded) return;
    window.__sjwCurrencySelectorLoaded = true;
    var ddUid = 0;
    // Group the appearance toggle + currency selector into ONE flex wrapper so
    // they share a grid cell and always sit side by side.
    function group(togSel, curSel) {
      var tog = document.querySelector(togSel), cur = document.querySelector(curSel);
      if (!tog || !cur || tog.parentElement !== cur.parentElement) return;
      if (tog.parentElement.classList.contains('sjw-mode-cur-group')) return;
      var w = document.createElement('div');
      w.className = 'sjw-mode-cur-group';
      tog.parentNode.insertBefore(w, tog);
      w.appendChild(tog); w.appendChild(cur);
    }

    function initDD(root) {
      if (root.dataset.sjwDdBound) return;
      root.dataset.sjwDdBound = '1';
      var btn = root.querySelector('.sjw-cur-dd__btn');
      var panel = root.querySelector('.sjw-cur-dd__panel');
      if (!btn || !panel) return;
      var options = Array.prototype.slice.call(root.querySelectorAll('[data-cur-opt]'));
      var meta = (window.SJW_CUR && window.SJW_CUR.meta) || {};

      panel.id = 'sjw-cur-list-' + (++ddUid);
      btn.setAttribute('aria-controls', panel.id);
      options.forEach(function (o) { o.setAttribute('tabindex', '-1'); });

      // fill each option's symbol from the engine's currency table
      root.querySelectorAll('[data-cur-opt]').forEach(function (o) {
        var c = o.getAttribute('data-cur-opt');
        var s = (meta[c] && meta[c].sym) || '';
        var el = o.querySelector('.sjw-cur-dd__sym');
        if (el) el.textContent = (s && s !== c) ? s : '';
      });

      function mark() {
        var cur = (window.SJW_CUR && window.SJW_CUR.state && window.SJW_CUR.state.cur) || 'USD';
        btn.setAttribute('aria-label', 'Choose display currency, ' + cur);
        options.forEach(function (o) {
          o.setAttribute('aria-selected', o.getAttribute('data-cur-opt') === cur ? 'true' : 'false');
        });
      }
      function selectedIndex() {
        var index = options.findIndex(function (o) { return o.getAttribute('aria-selected') === 'true'; });
        return index < 0 ? 0 : index;
      }
      function focusOption(index) {
        if (!options.length) return;
        var next = (index + options.length) % options.length;
        options[next].focus();
      }
      function close(returnFocus) {
        root.removeAttribute('data-open');
        panel.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        if (returnFocus) btn.focus();
      }
      function open(focusIndex) {
        mark();
        root.setAttribute('data-open', '');
        panel.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        if (typeof focusIndex === 'number') {
          window.requestAnimationFrame(function () { if (!panel.hidden) focusOption(focusIndex); });
        }
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        panel.hidden ? open(selectedIndex()) : close(false);
      });
      btn.addEventListener('keydown', function (e) {
        var index;
        if (e.key === 'ArrowDown') index = selectedIndex();
        else if (e.key === 'ArrowUp') index = selectedIndex() - 1;
        else if (e.key === 'Home') index = 0;
        else if (e.key === 'End') index = options.length - 1;
        else if (e.key === 'Escape' && !panel.hidden) {
          e.preventDefault();
          close(true);
          return;
        } else return;
        e.preventDefault();
        panel.hidden ? open(index) : focusOption(index);
      });
      options.forEach(function (o, optionIndex) {
        o.addEventListener('click', function (e) {
          e.stopPropagation();
          if (window.SJW_CUR) window.SJW_CUR.set(o.getAttribute('data-cur-opt'), true);
          mark(); close(true);
        });
        o.addEventListener('keydown', function (e) {
          var next;
          if (e.key === 'ArrowDown') next = optionIndex + 1;
          else if (e.key === 'ArrowUp') next = optionIndex - 1;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = options.length - 1;
          else if (e.key === 'Escape') {
            e.preventDefault();
            close(true);
            return;
          } else if (e.key === 'Tab') {
            close(false);
            return;
          } else return;
          e.preventDefault();
          focusOption(next);
        });
      });
      document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(false); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.hasAttribute('data-open')) close(root.contains(document.activeElement));
      });
      document.addEventListener('sjw:currency', mark);
      mark();
    }

    // Mobile: relocate the selector into the footer (in the header it squeezed
    // the wordmark off-centre). One clone, created once, kept in sync by the
    // engine's own sjw:currency listener. Owner call 2026-07-29.
    function toFooter() {
      if (!window.matchMedia || !window.matchMedia('(max-width: 989px)').matches) return;
      if (document.querySelector('.sjw-cur-foot')) return;
      var src = document.querySelector('.sjw-cur-select--mobile');
      if (!src) return;
      // Must land INSIDE the footer's own content wrapper — appending to the
      // section shell dropped the strip below the pine band, on white.
      var footer = document.querySelector('footer .sjwf-wrap')
        || document.querySelector('footer .footer__container')
        || document.querySelector('footer')
        || document.querySelector('[class*="footer-group"]');
      if (!footer) return;
      var host = document.createElement('div');
      host.className = 'sjw-cur-foot';
      // appearance toggle rides along — mobile header keeps only burger/search/
      // wordmark/wishlist/cart, so the wordmark stays centred.
      var tog = document.querySelector('.sjw-theme-mode-toggle--mobile');
      if (tog) {
        var tclone = tog.cloneNode(true);
        tclone.classList.remove('sjw-theme-mode-toggle--mobile');
        tclone.removeAttribute('data-sjw-theme-bound');
        host.appendChild(tclone);
      }
      var moved = src.cloneNode(true);
      moved.classList.remove('sjw-cur-select--mobile');
      moved.removeAttribute('data-sjw-dd-bound');
      host.appendChild(moved);
      // back to top — the mobile footer is long, so give people a way back up
      var up = document.createElement('button');
      up.type = 'button';
      up.className = 'sjw-totop';
      up.setAttribute('aria-label', 'Back to top');
      up.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V6M6 12l6-6 6 6"/></svg>';
      up.addEventListener('click', function () {
        var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
        window.scrollTo({ top: 0, behavior: rm ? 'auto' : 'smooth' });
        window.setTimeout(function () {
          var target = document.getElementById('MainContent') || document.querySelector('main') || document.querySelector('header');
          if (!target) return;
          var temporaryTabindex = !target.hasAttribute('tabindex');
          if (temporaryTabindex) target.setAttribute('tabindex', '-1');
          try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
          if (temporaryTabindex) {
            target.addEventListener('blur', function () { target.removeAttribute('tabindex'); }, { once: true });
          }
        }, rm ? 0 : 650);
      });
      host.appendChild(up);
      footer.appendChild(host);
      initDD(moved);
      // rebind the appearance toggle clone through the mode engine
      document.dispatchEvent(new CustomEvent('shopify:section:load'));
    }

    function bind() {
      group('.sjw-theme-mode-toggle--desktop', '.sjw-cur-select--desktop');
      group('.sjw-theme-mode-toggle--mobile', '.sjw-cur-select--mobile');
      document.querySelectorAll('[data-sjw-cur-dd]').forEach(initDD);
      toFooter();
      bindFooterChatVisibility();
    }
    var footerChatObserver = null;
    var observedFooter = null;
    var footerChatShowTimer = null;
    function moveFocusFromChatLauncher() {
      var host = document.activeElement;
      if (!host || !host.matches || !host.matches('shopify-chat, shopify-agent')) return;
      var active = host.shadowRoot && host.shadowRoot.activeElement;
      var activator = active && (
        active.matches('[part~="activator"]')
          ? active
          : active.closest('[part~="activator"]')
      );
      if (!activator) return;

      function isVisible(el) {
        if (!el || !el.getClientRects().length) return false;
        var rect = el.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
      }
      var footer = observedFooter || document.querySelector('footer.sjwf[role="contentinfo"]');
      var target = footer && Array.prototype.slice.call(
        footer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])')
      ).find(isVisible);
      if (!target) target = footer;
      if (!target) return;
      var temporaryTabindex = target === footer && !target.hasAttribute('tabindex');
      if (temporaryTabindex) target.setAttribute('tabindex', '-1');
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
      if (temporaryTabindex) {
        target.addEventListener('blur', function () { target.removeAttribute('tabindex'); }, { once: true });
      }
    }
    function setFooterChatHidden(hidden) {
      if (footerChatShowTimer) {
        window.clearTimeout(footerChatShowTimer);
        footerChatShowTimer = null;
      }
      if (hidden) {
        moveFocusFromChatLauncher();
        document.documentElement.setAttribute('data-sjw-footer-inview', '');
        return;
      }
      footerChatShowTimer = window.setTimeout(function () {
        footerChatShowTimer = null;
        var footer = observedFooter;
        if (footer && footer.isConnected) {
          var rect = footer.getBoundingClientRect();
          if (
            rect.width > 0 &&
            rect.height > 0 &&
            rect.top < window.innerHeight &&
            rect.bottom > 0
          ) return;
        }
        document.documentElement.removeAttribute('data-sjw-footer-inview');
      }, 100);
    }
    function clearFooterChatVisibility() {
      if (footerChatObserver) footerChatObserver.disconnect();
      if (footerChatShowTimer) window.clearTimeout(footerChatShowTimer);
      footerChatObserver = null;
      footerChatShowTimer = null;
      observedFooter = null;
      document.documentElement.removeAttribute('data-sjw-footer-inview');
    }
    function bindFooterChatVisibility() {
      var footer = document.querySelector('footer.sjwf[role="contentinfo"]');
      if (!footer) {
        clearFooterChatVisibility();
        return;
      }
      if (observedFooter === footer) return;
      if (footerChatObserver) footerChatObserver.disconnect();
      if (!('IntersectionObserver' in window)) {
        clearFooterChatVisibility();
        return;
      }
      observedFooter = footer;
      var rect = footer.getBoundingClientRect();
      setFooterChatHidden(
        rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0
      );
      footerChatObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== observedFooter) return;
          setFooterChatHidden(
            entry.isIntersecting &&
            entry.intersectionRect.width > 0 &&
            entry.intersectionRect.height > 0
          );
        });
      }, { threshold: [0, 0.000001] });
      footerChatObserver.observe(footer);
    }
    function handleMobileBreakpoint(e) {
      var outgoing = e.matches
        ? document.querySelector('.sjw-cur-select--desktop[data-sjw-cur-dd]')
        : document.querySelector('.sjw-cur-foot [data-sjw-cur-dd]');
      var transferFocus = outgoing && (
        outgoing.contains(document.activeElement) || outgoing.hasAttribute('data-open')
      );
      var panel = outgoing && outgoing.querySelector('.sjw-cur-dd__panel');
      var btn = outgoing && outgoing.querySelector('.sjw-cur-dd__btn');
      if (outgoing) outgoing.removeAttribute('data-open');
      if (panel) panel.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
      bind();
      if (transferFocus) {
        window.requestAnimationFrame(function () {
          function isVisible(el) {
            if (!el || !el.getClientRects().length) return false;
            var rect = el.getBoundingClientRect();
            return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
          }
          var incomingBtn = e.matches
            ? document.querySelector('.sjw-cur-foot .sjw-cur-dd__btn')
            : document.querySelector('.sjw-cur-select--desktop .sjw-cur-dd__btn');
          var fallback = document.getElementById('MainContent') || document.querySelector('main');
          var officeBtn = document.querySelector('.sjwf-offices-toggle');
          var headerTarget = Array.prototype.slice.call(
            document.querySelectorAll('header button:not([disabled]), header a[href]')
          ).find(isVisible);
          var target = [incomingBtn, officeBtn, headerTarget].find(isVisible) || fallback;
          if (!target) return;
          var temporaryTabindex = target === fallback && !target.hasAttribute('tabindex');
          if (temporaryTabindex) target.setAttribute('tabindex', '-1');
          try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
          if (temporaryTabindex) {
            target.addEventListener('blur', function () { target.removeAttribute('tabindex'); }, { once: true });
          }
        });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
    else bind();
    document.addEventListener('shopify:section:load', bind);
    document.addEventListener('shopify:section:unload', function () {
      window.requestAnimationFrame(bindFooterChatVisibility);
    });
    window.addEventListener('pageshow', function () {
      if (footerChatObserver) footerChatObserver.disconnect();
      footerChatObserver = null;
      observedFooter = null;
      bindFooterChatVisibility();
    });
    // crossing the mobile breakpoint after load must still build the footer host
    if (window.matchMedia) {
      var mq = window.matchMedia('(max-width: 989px)');
      if (mq.addEventListener) mq.addEventListener('change', handleMobileBreakpoint);
      else if (mq.addListener) mq.addListener(handleMobileBreakpoint);
    }
  })();
